import { Box, Typography } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

export default function DataSemResultados({
    texto,
    size = 'small'
}: DataSemResultadosProps) {
    return (
        <Box display="flex" gap={1} alignItems="center" justifyContent="center">
            <InfoIcon fontSize={size} sx={{ color: "gray" }} />
            <Typography variant={"caption"} fontSize={size}>{texto}</Typography>
        </Box>
    )
}

interface DataSemResultadosProps {
    texto: string
    size?: 'small' | 'medium' | 'large'
}